import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const REF_DURATION_DAYS = 30;

export default function AffiliateRedirect() {
  const { slug } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const trackAndRedirect = async () => {
      try {
        await axios.get(`${API_URL}/api/r/${slug}`);
      } catch (err) {
        // Track failure is non-blocking
      }

      // Store ref with 30-day expiry timestamp
      const expiry = Date.now() + REF_DURATION_DAYS * 24 * 60 * 60 * 1000;
      localStorage.setItem('affiliate_ref', slug);
      localStorage.setItem('affiliate_ref_expiry', expiry.toString());

      navigate('/', { replace: true });
    };

    trackAndRedirect();
  }, [slug, navigate]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-primary mx-auto mb-4"></div>
        <p className="text-sm text-muted-foreground">Redirection...</p>
      </div>
    </div>
  );
}
